const getMetaByWidgetType = (widget) => {
  if (widget === "search") {
    return findify.grid.state.meta;
  }
  if (widget === "autocomplete") {
    return findify.autocomplete.state.meta;
  }
  if (widget.includes("findify-rec")) {
    return findify.recommendation.state[widget]?.response?.meta;
  }
  throw new Error(`there is no meta for widget type : ${widget}`);
};

const initProductCardAnalytics = (id, properties) => {
  const meta = getMetaByWidgetType(properties.widget);

  try {
    findify.core.analytics?.sendEvent("click-item", {
      rid: meta.rid,
      item_id: id,
      variant_item_id: properties.selected_variant_id,
    });
  } catch (error) {
    console.log("error", error);
  }
};

const savePosition = (id, page) => {
  const url = window.location.href
  sessionStorage.setItem('product', JSON.stringify({id, url, page}))
}

const initOnProductCardClick = (id, page, properties) => {
  document.getElementById(id).addEventListener("click", (e) => {
    initProductCardAnalytics(id, properties);
    savePosition(id, page);
  });
};

const cleanActiveSwatches = (productCard) => {
  productCard.querySelectorAll('.findify-color-swatch').forEach((swatch) => 
   swatch.classList.remove('active'));
}

const setProductUrl = (productCard, url) => {
  productCard.querySelectorAll('.findify-product-link').forEach((aTag) =>
    aTag.setAttribute("href", url)
  );
}

const onSwatchClick = (event, product_url, variant_url, variant_image) => {
  
  const targetedSwatch = event.target;
  const productCard = targetedSwatch.closest('div[id].findify-product-card');
  const swatchImage = productCard.querySelector(`.findify-product-swatch-image`);
  
  if(targetedSwatch.classList.contains('active')) {

    cleanActiveSwatches(productCard);
    setProductUrl(productCard, product_url);
    swatchImage.setAttribute('hidden', true);
  }
  else {
    cleanActiveSwatches(productCard);
    targetedSwatch.classList.add('active');
    
    setProductUrl(productCard, variant_url);
    swatchImage.removeAttribute('hidden');
    swatchImage.src = `//cdn.shopify.com/s/files/${variant_image}`;
  }
}

const openPopupButtonsSelector = '.js-open-popup';

function closeAllPopups() {
    const allPopups = document.querySelectorAll('.popup-dialog');
    allPopups.forEach(popup => {
        popup.style.display = 'none';
    });
}

function handlePopupButtons(buttons) {
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            closeAllPopups();

            const targetId = this.getAttribute('data-target');
            const productId = this.getAttribute('data-productid');
            const popupDialog = document.getElementById(targetId);
            if (popupDialog) {
                popupDialog.style.display = 'block';

                const closeButton = popupDialog.querySelector('.close-button');
                closeButton.addEventListener('click', function() {
                    popupDialog.style.display = 'none';
                });

                window.addEventListener('click', function(event) {
                    if (event.target == popupDialog) {
                        popupDialog.style.display = 'none';
                    }
                });
            }
        });
    });
}

function addItemToCart(form) {

  const variantId = form.querySelector('input[name="id"]').value; 
  const formData = new FormData();
  formData.append('id', variantId);

  fetch('/cart/add', {
      method: 'POST',
      body: formData,
  })


}

function handleAddToCartButtons(buttons) {
    buttons.forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault();
            const form = button.closest('form');
            if (form) {
                addItemToCart(form);
            } 
        });
    });
}

handlePopupButtons(document.querySelectorAll(openPopupButtonsSelector));
handleAddToCartButtons(document.querySelectorAll('button[data-add-to-cart]'));

const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
            const newPopupButtons = [];
            const newAddToCartButtons = [];
            mutation.addedNodes.forEach(node => {
                if (node.matches && node.matches(openPopupButtonsSelector)) {
                    newPopupButtons.push(node);
                } else if (node.querySelectorAll) {
                    newPopupButtons.push(...node.querySelectorAll(openPopupButtonsSelector));
                    newAddToCartButtons.push(...node.querySelectorAll('button[data-add-to-cart]'));
                }
            });
            handlePopupButtons(newPopupButtons);
            handleAddToCartButtons(newAddToCartButtons);
        }
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});
